module.exports = __webpack_public_path__ + "static/img/4807_phase_function_Paper_PointsHejduk_Prediction.a102d8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4807_phase_function_Paper_PointsHejduk_Prediction.png
// module id = yo2n
// module chunks = 0